import { render, staticRenderFns } from "./ReportsPage.vue?vue&type=template&id=1289993b&scoped=true&"
import script from "./ReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289993b",
  null
  
)

export default component.exports